<div id="personal-details" class="d-flex flex-row flex-wrap">

    <!-- banner goes here -->
    <div class="w-100" *ngIf="(wording$|async)?.pageBanner; let banner">
     <app-banner [bannerText]="banner"></app-banner>
    </div>

    <div class="section" [ngClass]="{'pe-3': screenWidth>992}">
        <app-component-wrapper icon="warning" header="Attention" headerclass="danger" *ngIf="(wording$|async)?.attentionText; let attentionText;">
            <div class="description" slot="start">
                <div [innerHTML]="attentionText"></div>
            </div>
        </app-component-wrapper>

        <app-component-wrapper icon="insert_drive_file" header="Name Change & Date of Birth" *ngIf="(wording$|async)?.nameChangeDobText; let nameChangeDobText;">
            <div class="description" slot="start">
                <div [innerHTML]="nameChangeDobText"></div>
            </div>
        </app-component-wrapper>

        <app-component-wrapper icon="groups" header="Beneficiaries"
            *featuretoggle="personalDetailsBeneficiaryFeatureToggle">
            <div class="description" slot="start">
                <div [innerHTML]="'profileView_Beneficiaries'| message | async"></div>
            </div>
        </app-component-wrapper>
    </div>

    <div class="section">
        <app-component-wrapper icon="assignment_ind" header="Member Details">
            <div class="d-flex flex-column" slot="start">
                <app-member-view [hideTfn]="false"></app-member-view>
            </div>
            <div class="d-flex flex-row components-actions" slot="actions">
                <app-button *featuretoggle="updatePersonalDetailsFeatureToggle" class=" me-1 ms-1" title="Update"
                    icon="{{'BTN.personal-details.update.icon' | translate}}" (onClick)="onMemberEditClick()">
                </app-button>
            </div>
        </app-component-wrapper>
    </div>

</div>